import React from 'react';

import { formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import TextButton from 'CommonComponents/TextButton';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

function ProcurementPoliciesTableRow(props) {
    return (
        <>
            <tr className="tw-cursor-pointer">
                <td>{Number(props.policy.total_cost) ? formatToFixedMoneyWithLocale(props.policy.total_cost) : props.policy.total_cost}</td>
                <td>{props.policy.method}</td>
                <td>{props.policy.details}</td>
                <td>
                    <div className="tw-flex tw-items-center tw-gap-x-3">
                        <TextButton onClick={() => props.editPolicy(props.policy)}>
                            <EditIcon className="tw-w-3 tw-h-3" />
                            {$t('Edit')}
                        </TextButton>
                        <TextButton onClick={() => props.deletePolicy(props.policy)}>
                            <TrashIcon className="tw-w-3 tw-h-3" />
                            {$t('Delete')}
                        </TextButton>
                    </div>
                </td>
            </tr>
        </>
    );
}

export default ProcurementPoliciesTableRow;
